export default __webpack_public_path__ + "static/media/travelRussell.ae48bb9c.svg";